/** Outside the 24h window, Instagram DM allows HUMAN_AGENT when approved in Meta. */
export const INSTAGRAM_MESSAGE_TAGS = ["HUMAN_AGENT"];
